



























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { PatientModel } from "@/models/patient";
import { EventModel, EventType, EventStatus } from "@/models/event";
import EventDetail from "@/components/EventDetail/index.vue";
import { EventTypeIcon } from "@/components/EventType";
import { auth as authStore, auth, patient as store } from "@/store/modules";
import { format, parse } from "date-fns";
import { inject } from "inversify-props";
import { IEventService, IPatientService, EventFilter } from "@/interfaces/Services";
import MassActionPerformModal, { MassActionItem } from '@/components/MassActionPerformModal.vue';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

export enum EventActionable { IsPending = 'IsPending' }

@Component({
  components: {
    EventDetail,
    EventTypeIcon,
    MassActionPerformModal,
  }
})
export class EventsTableCard extends Vue {
  @inject(DependencyIdentifiers.EventService)
  private eventService!: IEventService;
  @inject(DependencyIdentifiers.PatientService)
  private patientService!: IPatientService;

  @Prop({required: true})
  private patients!: Array<PatientModel>;

  @Prop({required: true})
  private filter!: EventFilter;

  @Prop({required: false, default: false})
  private flat?: boolean;

  private isLoading = false;
  private componentKey = 0;
  
  private updateStatusModal = {
    visible: false,
    inProgress: false,
    queue: [] as MassActionItem[]
  };

  private items: Array<EventModel> = [];
  private total = 0;
  private selected: EventModel[] = [];

  private get headers() {
    return [
      {
        text: this.$t('event.fields.occuredAt'),
        align: "left",
        sortable: true,
        value: "occurredAt"
      },
      {
        text: this.$t('event.fields.patientName'),
        align: "left",
        sortable: false,
        value: "name"
      },
      {
        text: this.$t('event.fields.status'),
        align: "left",
        sortable: false,
        value: "status",
      },
      {
        text: this.$t('event.fields.type'),
        align: "left",
        sortable: false,
        value: "type"
      },
      {
        text: "",
        value: "action",
        sortable: false,
        align: "right"
      },
      { text: "", value: "data-table-expand" }
    ];
  }

  private options = {
    page: 1,
    itemsPerPage: 10,
    sortBy: ["occurredAt"],
    sortDesc: [true],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false
  };

  private get statusMap() {
    return ["draft", "pending", "approved", "rejected"]
      .map(status => ({
        value: status,
        text: this.$t(`event.status.${status}`) as string
      }));
  }

  private expanded: EventModel[] = [];
  private singleExpand = false;

  get isPatient() {
    return authStore.isPatient;
  }

  get computedHeaders() {
    if (this.filter.patientId !== null && this.filter.patientId !== undefined) {
      return this.headers.filter(header => header.text !== this.$t('event.fields.patientName'));
    }
    return this.headers;
  }

  isFlat() {
    return this.flat;
  }

  async mounted() {
    if (this.isPatient) {
      this.filter.patientId = authStore.authPatientId;
    }

    await this.load();
  }

  private async load() {
    this.isLoading = true;
    this.selected = [];
    try {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const [items, total] = await this.eventService.getMany(
        page,
        itemsPerPage,
        this.filter
      );

      this.total = total;
      this.items = [...items];
    } finally {
      this.isLoading = false;
    }
  }

  private async reset() {
    this.options.page = 1;
    await this.load();
  }

  resolvePatientById(patientId: string) {
    let patient = Object.values(store.items).find(
      ({ $patientId }) => $patientId === patientId
    );
    if (patient) {
      return patient.name;
    }
    patient = this.patients.find(({ $id }) => $id === patientId);
    if (patient) {
      return patient.name;
    }
    return null;
  }

  resolveStatus(raw: string): string {
    const match = this.statusMap.find(i => i.value == raw);
    return match ? match.text : raw;
  }

  private isSelectedActionable(
    items: EventModel[],
    check: EventActionable,
    matchAll: boolean = true,
  ): boolean {
    let matchCount: number = 0;
    items.forEach((item) => {
      switch (check) {
        case EventActionable.IsPending:
          if (item.status == EventStatus.Pending) {
            matchCount++;
          }
          break;
        default:
          throw new Error(`Unknown [EventActionable.${check}].`);
          break;
      }
    });

    return matchAll ? matchCount == items.length : matchCount > 0;
  }

  updateStatus(items: EventModel[], targetState: string) {
    this.updateStatusModal.queue = [...items].map<MassActionItem>((item: EventModel) => {
      return {
        model: item,
        identifier: item.occurredAt.toString(),
        getActionResult: async () => await this.eventService.update(item.$id!.toString(), {status: targetState})
      };
    });
    this.updateStatusModal.inProgress = true;
    this.updateStatusModal.visible = true;
  }

  @Watch("options", { deep: true })
  async onOptionsChange(val: any, oldVal: any) {
    await this.load();
    this.$emit('options-changed', this.options);
  }

  @Watch("filter", {deep: true})
  onFilterUpdate() {
    this.reset();
  }

  onStateUpdateComplete() {
    this.updateStatusModal.inProgress = false;
  }

  onStateUpdateModalClose() {
    this.updateStatusModal.inProgress = false;
    this.updateStatusModal.visible = false;
    this.updateStatusModal.queue = [];
    this.load();
  }
}

export default EventsTableCard;
